export const getCurrentParams = state =>
  state.parameters.clubParams[state.parameters.currentParams] || {};
const getClubParams = state => state.parameters.clubParams;
export default {
  getCurrentParams,
  getClubParams,
};
